var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"#fff"}},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.currentData.bt))]),_c('p',{staticClass:"white"},[_vm._v(_vm._s(_vm.currentData.fbsj && _vm.currentData.fbsj.slice(0, 10)))]),_c('div',{staticClass:"nr ql-editor",domProps:{"innerHTML":_vm._s(decodeURIComponent(_vm.currentData.nr))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }